import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { TurnoLavoratore } from "./TurnoLavoratore";
import { RipetiGiorno } from "./RipetiGiorno";
import { FaPlus } from 'react-icons/fa';
import { getSede } from './turniHelper';
import moment from "moment";
import 'moment/locale/it'
moment.locale('it');

export function TurniGiorno(props) {
    const closePopup = (close) => {
        if (typeof close === 'function') {
            close();
        }
    }

    const checkNotFerie = () => {
        return props.ferie.every((ferie) => ferie.tipo !== "FERIE");
    }

    const addTurno = (data, close) => {
        props.setMessage([])
        data.messaggi.map((value, key) => (
            props.setMessage(message => [...message, {
                descrizione: value.messaggio,
                tipo: value.tipo.toLowerCase()
            }])
        ))
        for (var i = 0; i < props.turni.length; i++) {
            if (props.turni[i].id === data.turno.id) {
                props.turni.splice(i, 1);
            }
        }
        props.turni.push(data.turno);
        props.turni.sort(function (a, b) {
            return a.inizio > b.inizio
        })
        closePopup(close);
        props.setRefreshSettimaneConTurni(Date.now())
    }
    const eliminaTurno = (data, close) => {
        props.setMessage([]);
        data.messaggi.map((value, key) => (
            props.setMessage(message => [...message,
            { descrizione: value.descrizione, tipo: value.tipo }])
        ))
        for (var i = 0; i < props.turni.length; i++) {
            if (props.turni[i].id === data.id) {
                props.turni.splice(i, 1);
            }
        }
        closePopup(close);
        props.setRefreshSettimaneConTurni(Date.now())
    }

    const formatPostazione = (sedeId, postazione) => {
        const sede = getSede(props.sedi, sedeId);
        var postazioni = sede.postazioni
        var postazioneDesc = "";
        if (postazioni) {
            postazioneDesc = postazioni[postazione];
        }
        return sede ? sede.descrizione + "/" + postazioneDesc : "sconosciuta";
    }

    const formatServizio = (servizio) => {
        return props.servizi[servizio][0];
    }

    const formatTurno = (turno) => {
        return turno.inizio + "-"
            + turno.fine + " "
            + formatPostazione(turno.sedeId, turno.postazione) + ": "
            + formatServizio(turno.servizioId)
    }

    const formatFerie = (ferie) => {
        let descrizione = ""
        if (ferie.tipo === 'FERIE') {
            descrizione = "FERIE"
        } else {
            descrizione = "PERMESSO " + moment(ferie.inizio).format("HH:mm") + "-" + moment(ferie.fine).format("HH:mm")
        }
        return descrizione;
    }

    const getClassForSede = (sedeId) => {
        const sede = props.sedi.find(sede => sede.id === sedeId);
        return sedeId ? { backgroundColor: sede.colore } : {};
    };

    const getClassForFeriePermessi = (ferie) => {
        let classCss = ""
        if (ferie.tipo === 'FERIE') {
            classCss = { backgroundColor: "red" }
        } else {
            classCss = { backgroundColor: "orange" }
        }
        return classCss;
    };

    const getPopup = (trigger, turno, cssClass, index) => {
        return <Popup
            trigger={<button className={`${cssClass}`} style={getClassForSede(turno.sedeId)} id={index}>{trigger}</button>}
            position="bottom center"
            modal>{
                close =>
                    <TurnoLavoratore
                        id={turno.id}
                        sede={turno.sedeId}
                        inizio={turno.inizio}
                        fine={turno.fine}
                        postazione={turno.postazione}
                        servizio={turno.servizioId}
                        sedi={props.sedi}
                        servizi={props.servizi}
                        lavoratore={props.lavoratore}
                        giorno={props.giorno}
                        mattina={props.mattina}
                        action={(data) => addTurno(data, close)}
                        eliminaAction={(data) => eliminaTurno(data, close)}
                        close={close}
                        lavoratori={props.lavoratori}
                        lavoratoreDisable={props.lavoratoreDisable}
                        postazioneDisable={props.postazioneDisable}
                        sedeDisable={props.sedeDisable}
                        setRefreshSettimaneConTurni={props.setRefreshSettimaneConTurni}
                    />
            }
        </Popup>
    }


    const getRipetizioneGiornoPopup = (turno, cssClass, index) => {
        return <Popup
            className='dimensione'
            trigger={<button className={`${cssClass}`} id={index + '-ripeti'}>Ripeti</button>}
            modal>{
                close => (
                    <RipetiGiorno
                        turno={turno}
                        settimana={props.settimana}
                        mattina={props.mattina}
                        closeTooltip={close}
                        close={close}
                        aggiungiTurnoRipetuto={props.aggiungiTurnoRipetuto}
                        setMessage={props.setMessage}
                        setRefreshSettimaneConTurni={props.setRefreshSettimaneConTurni}
                    />)
            }
        </Popup>
    }

    return (<>
        {checkNotFerie() && getPopup(<FaPlus />, { id: "", inizio: null, fine: null }, 'aggiungiTurno', props.index)}
        {props.ferie.map((ferie, keyFerie) => (
            <div className="row" key={`${props.index}ferie-${keyFerie}`}>
                <div className='ferieButton' key={`${props.index}ferie-${keyFerie}-popup`}>{
                    <button className={"turnoFerie"} id={`${props.index}ferie-${keyFerie}`} style={getClassForFeriePermessi(ferie)}>{formatFerie(ferie)}</button>
                }</div>
            </div>))}
        {props.turni.map((turno, keyTurno) => (
            <div className="row" key={`${props.index}turno-${keyTurno}`}>
                <div className='turno' key={`${props.index}turno-${keyTurno}-popup`}>{
                    getPopup(formatTurno(turno), turno, 'triggerTurno', `${props.index}turno-${keyTurno}`)
                }</div>

                <div className='turno' key={`${props.index}turno-${keyTurno}-ripeti`}>{
                    getRipetizioneGiornoPopup(turno, 'ripetiTurno', `${props.index}turno-${keyTurno}`)
                }</div>
            </div>))}

    </>)
}
